import { render, staticRenderFns } from "./TaskDetailDependencies.vue?vue&type=template&id=64864964"
import script from "./TaskDetailDependencies.vue?vue&type=script&lang=js"
export * from "./TaskDetailDependencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports